var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2820_1128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2820_1128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2820_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1556 11.8428H11.8398V38.1586H38.1556V11.8428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1602 49.9993L50.0023 38.1572H38.1602V49.9993Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0023 11.8428H38.1602V38.1586H50.0023V11.8428Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1556 38.1572H11.8398V49.9993H38.1556V38.1572Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.1572V46.052C0 48.223 1.77632 49.9993 3.94737 49.9993H11.8421V38.1572H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0023 11.8421V3.94737C50.0023 1.77632 48.2259 0 46.0549 0H38.1602V11.8421H50.0023Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1579 0H3.94737C1.77632 0 0 1.77632 0 3.94737V38.1579H11.8421V11.8421H38.1579V0Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2367 32.2375C16.2499 31.5796 15.592 30.5927 15.1973 29.3427L17.4999 28.4217C17.6973 29.2112 18.092 29.8033 18.5525 30.2638C19.0788 30.7243 19.671 30.9217 20.3946 30.9217C21.1183 30.9217 21.7762 30.7243 22.3025 30.2638C22.8288 29.8033 23.092 29.2112 23.092 28.5533C23.092 27.8296 22.8288 27.2375 22.2367 26.7769C21.6446 26.3164 20.9867 26.1191 20.1315 26.1191H18.8157V23.8822H19.9999C20.7236 23.8822 21.3157 23.6848 21.842 23.2901C22.3683 22.8954 22.5657 22.3691 22.5657 21.6454C22.5657 21.0533 22.3683 20.5269 21.9078 20.198C21.4473 19.8033 20.921 19.6717 20.1973 19.6717C19.5394 19.6717 19.0131 19.8691 18.6183 20.198C18.2236 20.5269 17.8946 20.9875 17.7631 21.5138L15.5262 20.5927C15.8552 19.7375 16.3815 19.0138 17.171 18.3559C17.9604 17.698 19.0131 17.3691 20.2631 17.3691C21.1841 17.3691 22.0394 17.5664 22.7631 17.8954C23.4867 18.2243 24.0788 18.7506 24.4736 19.4085C24.8683 20.0664 25.0657 20.7243 25.0657 21.5138C25.0657 22.3033 24.8683 23.0269 24.4736 23.5533C24.0788 24.0796 23.6183 24.5401 23.0262 24.8691V25.0006C23.7499 25.3296 24.4078 25.7901 24.8683 26.448C25.3288 27.1059 25.592 27.8296 25.592 28.7506C25.592 29.6717 25.3946 30.4612 24.9341 31.1191C24.4736 31.7769 23.8815 32.3691 23.0262 32.7638C22.2367 33.1585 21.3157 33.3559 20.3288 33.3559C19.2762 33.2243 18.2236 32.8954 17.2367 32.2375ZM31.2499 20.9217L28.7499 22.7638L27.4999 20.8559L31.9736 17.6322H33.6841V32.8954H31.2499V20.9217Z",
    fill: "#4285F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2820_1128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.7151e0eb.svg";
export { ForwardRef as ReactComponent };